import React from 'react';
import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../contexts/AuthContext/AuthContext';
import { BreadCrumbLink } from '../FinancialData/Company/BreadCrumbs/BreadCrumbs';
import AuthenticatedHelpPage from './AuthenticatedHelpPage';
import UnauthenticatedHelpPage from './UnauthenticatedHelpPage';

export const PRODUCT_NAME = 'CompID';

interface OwnProps {
  path: string;
}

const Help: React.FunctionComponent<OwnProps> = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const breadCrumbs: BreadCrumbLink[] = [
    {
      text: t('app:navTab:help'),
    },
  ];

  ReactGA.pageview(window.location.pathname);

  if (user?.canAccess) {
    return <AuthenticatedHelpPage breadCrumbs={breadCrumbs} />;
  }
  return <UnauthenticatedHelpPage breadCrumbs={breadCrumbs} />;
};

export default Help;
